import { render, staticRenderFns } from "./LogicList.vue?vue&type=template&id=37a85e71&scoped=true&"
import script from "./LogicList.vue?vue&type=script&lang=js&"
export * from "./LogicList.vue?vue&type=script&lang=js&"
import style0 from "./LogicList.vue?vue&type=style&index=0&id=37a85e71&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a85e71",
  null
  
)

export default component.exports